export interface Question {
  id: string;
  question: string;
  options: { id: string; label: string }[];
  helpText?: string; // Optional explanation
}

export const questions: Question[] = [
  {
    id: "q1",
    question: "How long have you been in BC?",
    helpText: "This helps us understand if you need immediate first-step services or longer-term support.",
    options: [
      { id: "arrived_today", label: "Just arrived (this week)" },
      { id: "less_1month", label: "Less than 1 month" },
      { id: "1to3months", label: "1-3 months" },
      { id: "3to6months", label: "3-6 months" },
      { id: "more_6months", label: "More than 6 months" },
    ],
  },
  {
    id: "q2",
    question: "What is your immigration status?",
    helpText: "Different services are available based on your status. All information is confidential.",
    options: [
      { id: "pr", label: "Permanent Resident" },
      { id: "refugee", label: "Refugee / Protected Person" },
      { id: "work_permit", label: "Work Permit" },
      { id: "study_permit", label: "Study Permit" },
      { id: "refugee_claimant", label: "Refugee Claimant" },
    ],
  },
  {
    id: "q3",
    question: "What is your MOST URGENT need right now?",
    helpText: "Choose the one thing that's most important to you today. We'll help with other needs too.",
    options: [
      { id: "first_steps", label: "Basic setup (SIN, bank account, health insurance)" },
      { id: "housing", label: "Finding a place to live" },
      { id: "english", label: "Learning English" },
      { id: "job", label: "Finding a job" },
      { id: "family_support", label: "Support for my family/children" },
      { id: "mental_health", label: "Counselling or mental health support" },
    ],
  },
  {
    id: "q4",
    question: "What is your English level?",
    helpText: "Be honest - there are free classes for all levels!",
    options: [
      { id: "beginner", label: "Beginner (little to no English)" },
      { id: "intermediate", label: "Intermediate (can have basic conversations)" },
      { id: "advanced", label: "Advanced (fluent or near-fluent)" },
    ],
  },
  {
    id: "q5",
    question: "Do you have family or friends in BC who can help you?",
    helpText: "This helps us understand how much support you might need.",
    options: [
      { id: "yes_help", label: "Yes, they can help me" },
      { id: "yes_no_help", label: "Yes, but they cannot help much" },
      { id: "no_alone", label: "No, I'm completely alone" },
    ],
  },
  {
    id: "q6",
    question: "Where in BC do you live (or plan to live)?",
    helpText: "We'll recommend services closest to you.",
    options: [
      { id: "vancouver", label: "Vancouver" },
      { id: "burnaby", label: "Burnaby" },
      { id: "surrey", label: "Surrey / Delta / White Rock" },
      { id: "richmond", label: "Richmond" },
      { id: "tri_cities", label: "Tri-Cities (Coquitlam, New Westminster)" },
      { id: "other_metro", label: "Other Metro Vancouver" },
      { id: "other_bc", label: "Outside Metro Vancouver" },
    ],
  },
];
